var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { Focusable } from "@/common/mixins/Focusable";
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import DateInputRow from '@/common/components/DateInputRow.vue';
import PlainTextControl from '@/common/components/PlainTextControl.vue';
import TextLabelRow from '@/common/components/TextLabelRow.vue';
import AidYearAmountRow from '@/template/components/paymentPlan/AidYearAmountRow.vue';
import ValueDisplayRow from '@/common/components/ValueDisplayRow.vue';
import PaymentPlanTable from './PaymentPlanTable.vue';
import { PaymentPlan } from '@/common/types/PaymentPlan';
import moment from 'moment';
import EntityService from '@/common/services/EntityService';
import { Savable } from '@/common/mixins/Savable';
var PaymentPlanView = /** @class */ (function (_super) {
    __extends(PaymentPlanView, _super);
    function PaymentPlanView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entityService = new EntityService();
        _this.aidAmountKeys = [];
        return _this;
    }
    PaymentPlanView.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAidAmountKeys()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentPlanView.prototype.mounted = function () {
        this.focusOnFirstTag("h1");
    };
    Object.defineProperty(PaymentPlanView.prototype, "aidTargetWithAmounts", {
        get: function () {
            return this.paymentPlan.aidTargetWithAmounts;
        },
        enumerable: false,
        configurable: true
    });
    PaymentPlanView.prototype.createAidAmountKeys = function () {
        var _this = this;
        this.aidTargetWithAmounts.aidYearAmounts.forEach(function (x) { return _this.aidAmountKeys.push(x.lastAidUseDate.toString()); });
    };
    Object.defineProperty(PaymentPlanView.prototype, "validateAmount", {
        get: function () {
            var _this = this;
            if (this.paymentPlan.plannedRequests.every(function (x) { return x.date != null && _this.requestTotal(x) != 0; }))
                return true;
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentPlanView.prototype, "aidTargetNumber", {
        get: function () {
            return this.paymentPlan.record.aidTargetNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentPlanView.prototype, "availableAmount", {
        get: function () {
            return this.aidTargetWithAmounts ? this.aidTargetWithAmounts.availableAmount : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentPlanView.prototype, "aidYearAmounts", {
        get: function () {
            return this.aidTargetWithAmounts ? this.aidTargetWithAmounts.aidYearAmounts : [];
        },
        enumerable: false,
        configurable: true
    });
    PaymentPlanView.prototype.amountSpentByDate = function (amount) {
        var e_1, _a;
        var totalSpent = 0;
        try {
            for (var _b = __values(this.paymentPlan.plannedRequests), _c = _b.next(); !_c.done; _c = _b.next()) {
                var request = _c.value;
                if (moment(request.date).toDate() <= moment(amount.lastAidUseDate).toDate())
                    totalSpent += this.requestTotal(request);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return totalSpent;
    };
    PaymentPlanView.prototype.requestTotal = function (request) {
        return (request.personnelExpensesAmount || 0)
            + (request.operationalExpensesAmount || 0)
            + (request.premiseExpensesAmount || 0)
            + (request.generalExpensesAmount || 0);
    };
    Object.defineProperty(PaymentPlanView.prototype, "requestsTotal", {
        get: function () {
            var e_2, _a;
            var personnelExpensesTotal = 0;
            var premiseExpensesTotal = 0;
            var operationalExpensesTotal = 0;
            var generalExpensesTotal = 0;
            try {
                for (var _b = __values(this.paymentPlan.plannedRequests), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var request = _c.value;
                    personnelExpensesTotal += request.personnelExpensesAmount || 0;
                    premiseExpensesTotal += request.premiseExpensesAmount || 0;
                    operationalExpensesTotal += request.operationalExpensesAmount || 0;
                    generalExpensesTotal += request.generalExpensesAmount || 0;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return {
                date: null,
                generalExpensesAmount: generalExpensesTotal,
                operationalExpensesAmount: operationalExpensesTotal,
                personnelExpensesAmount: personnelExpensesTotal,
                premiseExpensesAmount: premiseExpensesTotal,
                totalAmount: generalExpensesTotal + operationalExpensesTotal + personnelExpensesTotal + premiseExpensesTotal
            };
        },
        enumerable: false,
        configurable: true
    });
    // renders aidYearAmountRows again so that validations work correctly.
    PaymentPlanView.prototype.onChange = function () {
        if (this.aidAmountKeys.length > 0) {
            for (var i = 0; i < this.aidAmountKeys.length; ++i) {
                this.aidAmountKeys[i] = Date.now().toString().concat(i.toString());
            }
        }
    };
    PaymentPlanView.prototype.refreshAidAmountValidation = function () {
        if (this.aidAmountKeys.length > 0) {
            for (var i = 0; i < this.aidAmountKeys.length; ++i) {
                this.aidAmountKeys[i] = Date.now().toString().concat(i.toString());
            }
        }
    };
    Object.defineProperty(PaymentPlanView.prototype, "remainingAvailableAmount", {
        get: function () {
            var tempNumber = this.aidTargetWithAmounts ? this.aidTargetWithAmounts.availableAmount : 0;
            tempNumber = tempNumber - this.requestsTotal.totalAmount;
            this.paymentPlan.unplannedAmount = tempNumber;
            return tempNumber;
        },
        enumerable: false,
        configurable: true
    });
    PaymentPlanView.prototype.getAidYearAmountTitle = function (aidYearAmount) {
        var lastAidUseDateStr = moment(aidYearAmount.lastAidUseDate).format("DD.MM.YYYY");
        return "" + this.$t("PaymentPlan.Information.Until", null, [lastAidUseDateStr]);
    };
    Object.defineProperty(PaymentPlanView.prototype, "earliestPaymentDate", {
        get: function () {
            var date = moment(Date.now()).add(7, 'days').toDate();
            return date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentPlanView.prototype, "latestPaymentDate", {
        get: function () {
            if (this.aidYearAmounts.length > 0) {
                var dates = this.aidYearAmounts.map(function (x) { return moment(x.lastAidUseDate).toDate(); });
                var latest = new Date(Math.max.apply(null, dates));
                return latest;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof PaymentPlan !== "undefined" && PaymentPlan) === "function" ? _a : Object)
    ], PaymentPlanView.prototype, "paymentPlan", void 0);
    __decorate([
        Watch("requestsTotal.totalAmount"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PaymentPlanView.prototype, "onChange", null);
    PaymentPlanView = __decorate([
        Component({
            name: "PaymentPlanView",
            components: {
                TextAreaRow: TextAreaRow,
                DateInputRow: DateInputRow,
                PlainTextControl: PlainTextControl,
                TextLabelRow: TextLabelRow,
                AidYearAmountRow: AidYearAmountRow,
                ValueDisplayRow: ValueDisplayRow,
                PaymentPlanTable: PaymentPlanTable
            }
        })
    ], PaymentPlanView);
    return PaymentPlanView;
}(Mixins(Focusable, Savable)));
export default PaymentPlanView;
